module.exports = __webpack_public_path__ + "2a7be03f45058d932aeacd88ee7a2f46.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1/public/games/Dawn-of-War-II.jpg
// module id = 347
// module chunks = 0